import React from 'react';
import { IButton } from './IButton';
import classNames from 'classnames';

const PrimarySquareBtn = (props: IButton) => {
  const { handleOnClick, children, width, disabled, hidden, } = props;
  return (
    <button
      style={{ width: width || 'auto' }}
      className={classNames(
        '!h-fit rounded-md px-3 py-2 font-normal bg-primary !leading-none text-white transition-shadow ease-in hover:shadow-md',
       
      )}
      onClick={handleOnClick}
      disabled={disabled}
      hidden={hidden}
    >
      {children}
    </button>
  );
};

export default PrimarySquareBtn;
